import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        {/* TOP DIVIDER LINE ACCENT */}
        <div className="footer-accent-bar" />

        <div className="footer-grid">

          {/* TRUST INFO */}
          <div className="footer-col footer-brand">
            <h5 className="footer-logo-title">Geetha Alagappan<br />Foundation</h5>
            <p className="footer-tagline">Care with Purpose.</p>
            <p className="footer-text">
              A charitable trust focused on emergency medical help,
              elder &amp; child care, accident relief, and support for
              small livelihood needs.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-col">
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-links">
              {[
                { label: "Home", to: "/" },
                { label: "About Us", to: "/about" },
                { label: "Requests", to: "/publicview" },
                { label: "Gallery", to: "/gallery" },
                { label: "Contact", to: "/contact" },
                { label: "Donators", to: "/donators" },
                { label: "Need Help", to: "/request" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link to={to}>
                    <span className="link-arrow">›</span> {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div className="footer-col">
            <h6 className="footer-heading">Contact</h6>
            <ul className="footer-contact">
              <li>
                <span className="contact-icon"><FaEnvelope /></span>
                <span>info@geethaalagappanfoundation.org</span>
              </li>
              <li>
                <span className="contact-icon"><FaPhoneAlt /></span>
                <span>+91 99444 41205</span>
              </li>
              <li>
                <span className="contact-icon"><FaMapMarkerAlt /></span>
                <span>Karaikudi, Tamil Nadu, India</span>
              </li>
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="footer-col footer-social-col">
            <h6 className="footer-heading">Follow Us</h6>
            <div className="footer-social">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
            </div>
            <p className="footer-social-note">Stay connected for updates on our initiatives and events.</p>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="footer-bottom">
          <span className="footer-copy">
            © {new Date().getFullYear()} Geetha Alagappan Foundation.
          </span>
          <span className="footer-motto">Care with Purpose.</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;